<div class="card-flight-container">
  <div class="card-flight">
    <div class="d-flex justify-content-between mb-1">
      <div class="flight-number-box">
        @for (segment of flight.flightSegments; track segment; let i = $index) {
          <span>
            LA{{segment.flightNumber}}{{i < flight.flightSegments.length - 1 ? '/' : '' }}
          </span>
        }
      </div>

      <div class="flight-available-seats text-end">
        <app-seat-availability [items]="flight.flightSegments"></app-seat-availability>
      </div>
  </div>

  <div>
    <div class="flight-box">
      <div class="flight-itinerary">
        <div class="flight-leg">
          <div>
            <span class="airport-code">{{ flight.flightSegments[0].originLocationCode }}</span>
            <span class="flight-time">{{ flight.flightSegments[0].departureDateTime | dateFormat: 'HH:mm'}}</span>
          </div>
          <img src="assets/images/airplane_flying.svg" alt="Avião">
        </div>
        <div class="flight-leg">
          <div>
            <span class="airport-code">{{ flight.flightSegments[0].destinationLocationCode }}</span>

            @if (!isMultiple) {
              <span class="flight-time" [ngClass]="{ 'days-diff': flight.flightSegments[0].arrivalDayDiffDepartureDay }"></span>
              <span class="flight-time"> {{ flight.flightSegments[0].arrivalDateTime | dateFormat: 'HH:mm' }}</span>
            }

            @if (isMultiple) {
              <span class="flight-time">{{ flight.flightSegments[0].arrivalDateTime | dateFormat: 'HH:mm'}}</span>
              <span class="flight-time">{{ flight.flightSegments[1].departureDateTime | dateFormat: 'HH:mm' }}</span>
              <span class="flight-time" [ngClass]="{ 'days-diff': flight.flightSegments[1].arrivalDayDiffDepartureDay}"></span>
            }
          </div>
          @if (isMultiple) {
            <img src="assets/images/airplane_flying.svg" alt="Avião">
          }
        </div>
        @if (isMultiple) {
          <div class="flight-leg">
            <div>
              <span class="airport-code">{{ flight.flightSegments[1].destinationLocationCode }}</span>
              <span class="flight-time">{{ flight.flightSegments[1].arrivalDateTime | dateFormat: 'HH:mm'}}</span>
              <span class="flight-time" [ngClass]="{ 'days-diff': flight.flightSegments[1].arrivalDayDiffDepartureDay }"></span>
            </div>
          </div>
        }
      </div>

      <div class="flight-info">
        <img src="assets/images/airplane_boarding.svg" alt="Avião">
        <span class="flight-stops">{{ isMultiple ? 'Parada' : 'Direto' }}</span>
        <div class="itinerary-collapase" (click)="toggleItinerary()">
          <span
            [ngClass]="{'itinerary-collapase_label': !isMultiple, 'itinerary-collapase_label_two': isMultiple}">
            Itinerário do voo
          </span>

          <span class="itinerary-collapase_arrow" #itineraryCollapase></span>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
